import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Register from "./components/Register";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import LandingPage from "./components/Landingpage";
import AdminDashboard from './components/Admin/AdminDashboard';
import AdminOverview from './components/Admin/AdminOverview';
import UserList from './components/Admin/UserList';
import CreateSuperuser from "./components/Admin/CreateSuperuser";
import UserLogs from "./components/Admin/UserLogs";
import TradeLogs from "./components/TradeLogs";
import AddAPI from "./components/AddAPI";
// import AddMT5 from "./components/AddMT5";
import MyModels from "./components/MyModels";
import Accounts from "./components/Accounts";
import AddIG from "./components/AddIG";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        
        {/* Main User Routes */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/my-models" element={<MyModels />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/trade-logs" element={<TradeLogs />} />
        
        {/* Setup Routes (Hidden from nav, accessed from Accounts page) */}
        <Route path="/add-api" element={<AddAPI />} />
        {/* <Route path="/add-mt5" element={<AddMT5 />} /> */}
        <Route path="/add-ig" element={<AddIG />} />

        
        {/* Admin Routes - Nested under AdminDashboard */}
        <Route path="/admin" element={<AdminDashboard />}>
          <Route index element={<AdminOverview />} />
          <Route path="users" element={<UserList />} />
          <Route path="trade-logs" element={<UserLogs />} />
        </Route>
        
        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;